import { InfoWindow, Marker } from '@react-google-maps/api';
import { memo, useState, useEffect } from 'react'
import { useTheme } from '@mui/material';

const infoWindowStyles = `
.gm-style-iw-c {
    padding: 0 !important;
    border-radius: 12px !important;
    overflow: hidden !important;
    box-shadow: 0 8px 30px rgba(3, 100, 255, 0.15), 0 2px 8px rgba(0,0,0,0.1) !important;
    border: 1px solid rgba(3, 100, 255, 0.2) !important;
}
.gm-style-iw-d {
    overflow: hidden !important;
    max-height: none !important;
}
.gm-style-iw-tc::after {
    background: #fff !important;
}
.gm-ui-hover-effect {
    display: none !important;
}
`;

const infoWindowDarkStyles = `
.gm-style-iw-c {
    padding: 0 !important;
    border-radius: 12px !important;
    overflow: hidden !important;
    background: #1F2A40 !important;
    box-shadow: 0 8px 30px rgba(0,0,0,0.4), 0 0 0 1px rgba(3, 100, 255, 0.3) !important;
    border: 1px solid #3d4a62 !important;
}
.gm-style-iw-d {
    overflow: hidden !important;
    max-height: none !important;
}
.gm-style-iw-tc::after {
    background: #1F2A40 !important;
}
.gm-ui-hover-effect {
    display: none !important;
}
`;

function MarkerClienteDash({
    coordenadas,
    item,
    ...defaultProps
}) {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [isVisible, setIsVisible] = useState(false);
    const [colorIcon, setcolorIcon] = useState('/img/antena2.png');

    // Normaliza campos para soportar estructura con sufijo _t (pre-servicios) y sin sufijo (tickets/servicios)
    const isPreServicio = item?.id_t !== undefined;
    const id = item?.id_t ?? item?.servicio;
    const nombre = item?.nombre_t ?? item?.nombreCliente;
    const plan = item?.nombrePlan;
    const tecnologia = item?.tipoTecnologia_t ?? item?.tipoTecnologia;
    const esServicio = isPreServicio ? !!item?.cuentaId_t : !!item?.cuenta;
    const estado = item?.estadoServicio_t;
    const direccion = item?.direccion_t;
    const autor = item?.autor?.nombre_p;
    const fechaCreacion = item?.fechaCreacion;
    const lat = item?.latitud_t ?? item?.latitud;
    const lng = item?.longitud_t ?? item?.longitud;

    useEffect(() => {
        switch (tecnologia) {
            case 'FO':
                setcolorIcon('/img/fibra-optica.png');
                break;
            default:
                setcolorIcon('/img/antena2.png');
                break;
        }
    }, [tecnologia]);

    const rowStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        fontSize: '12px',
        gap: '8px',
    };
    const labelStyle = { color: isDarkMode ? '#8899a6' : '#666', fontWeight: 500, whiteSpace: 'nowrap' };
    const valueStyle = { color: isDarkMode ? '#e0e0e0' : '#1a1a2e', fontWeight: 600, textAlign: 'right', maxWidth: '160px' };

    return (
        <Marker
            {...defaultProps}
            position={coordenadas}
            onClick={() => setIsVisible(!isVisible)}
            icon={{
                url: colorIcon,
                scaledSize: { width: 50, height: 50 },
            }}
        >
            {isVisible && (
                <>
                    <style>{isDarkMode ? infoWindowDarkStyles : infoWindowStyles}</style>
                    <InfoWindow
                        className="card"
                        position={coordenadas}
                        onCloseClick={() => setIsVisible(!isVisible)}
                    >
                        <div style={{
                            backgroundColor: isDarkMode ? '#1F2A40' : '#fff',
                            color: isDarkMode ? '#e0e0e0' : '#000',
                            borderRadius: '12px',
                            minWidth: '210px',
                            maxWidth: '260px',
                            fontFamily: "'Segoe UI', Roboto, sans-serif",
                            overflow: 'hidden',
                        }}>
                            {/* Header con franja azul */}
                            <div style={{
                                background: 'linear-gradient(135deg, #0364FF 0%, #0247B5 100%)',
                                padding: '10px 14px 10px 14px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: '8px',
                            }}>
                                <div style={{
                                    display: 'inline-block',
                                    background: esServicio
                                        ? 'rgba(255,255,255,0.25)'
                                        : 'rgba(255, 160, 0, 0.85)',
                                    color: '#fff',
                                    padding: '2px 9px',
                                    borderRadius: '4px',
                                    fontWeight: 700,
                                    fontSize: '10px',
                                    letterSpacing: '0.5px',
                                    border: '1px solid rgba(255,255,255,0.3)',
                                }}>
                                    {esServicio ? 'SERVICIO' : 'PRE-SERVICIO'}
                                </div>
                                <div style={{
                                    fontSize: '15px',
                                    fontWeight: 800,
                                    color: '#fff',
                                    letterSpacing: '0.3px',
                                    flex: 1,
                                    textAlign: 'center',
                                }}>
                                    {`#${id || ''}`}
                                </div>
                                <button
                                    onClick={() => setIsVisible(false)}
                                    style={{
                                        background: 'rgba(255,255,255,0.15)',
                                        border: '1px solid rgba(255,255,255,0.3)',
                                        borderRadius: '50%',
                                        width: '22px',
                                        height: '22px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        color: '#fff',
                                        fontSize: '13px',
                                        lineHeight: 1,
                                        padding: 0,
                                        flexShrink: 0,
                                    }}
                                >
                                    ✕
                                </button>
                            </div>

                            {/* Campos */}
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', padding: '12px 14px 10px 14px' }}>
                                {nombre && (
                                    <div style={rowStyle}>
                                        <span style={labelStyle}>Nombre</span>
                                        <span style={valueStyle}>{nombre}</span>
                                    </div>
                                )}
                                {estado && (
                                    <div style={rowStyle}>
                                        <span style={labelStyle}>Estado</span>
                                        <span style={{
                                            ...valueStyle,
                                            backgroundColor: isDarkMode ? 'rgba(3,100,255,0.2)' : 'rgba(3,100,255,0.08)',
                                            color: isDarkMode ? '#90caf9' : '#0247B5',
                                            padding: '2px 7px',
                                            borderRadius: '4px',
                                            fontSize: '10px',
                                            border: `1px solid ${isDarkMode ? 'rgba(3,100,255,0.3)' : 'rgba(3,100,255,0.2)'}`,
                                        }}>
                                            {estado}
                                        </span>
                                    </div>
                                )}
                                {tecnologia && (
                                    <div style={rowStyle}>
                                        <span style={labelStyle}>Tecnología</span>
                                        <span style={{
                                            ...valueStyle,
                                            backgroundColor: isDarkMode ? 'rgba(16,185,129,0.15)' : 'rgba(16,185,129,0.1)',
                                            color: isDarkMode ? '#6ee7b7' : '#065f46',
                                            padding: '2px 7px',
                                            borderRadius: '4px',
                                            fontSize: '10px',
                                            border: `1px solid ${isDarkMode ? 'rgba(16,185,129,0.25)' : 'rgba(16,185,129,0.2)'}`,
                                        }}>
                                            {tecnologia}
                                        </span>
                                    </div>
                                )}
                                {plan && (
                                    <div style={rowStyle}>
                                        <span style={labelStyle}>Plan</span>
                                        <span style={{
                                            ...valueStyle,
                                            backgroundColor: isDarkMode ? '#2d3a52' : '#f0f4ff',
                                            color: isDarkMode ? '#e0e0e0' : '#1a1a2e',
                                            padding: '2px 8px',
                                            borderRadius: '4px',
                                            fontSize: '11px',
                                        }}>
                                            {plan}
                                        </span>
                                    </div>
                                )}
                                {direccion && (
                                    <div style={rowStyle}>
                                        <span style={labelStyle}>Dirección</span>
                                        <span style={{ ...valueStyle, fontSize: '11px' }}>{direccion}</span>
                                    </div>
                                )}
                                {autor && (
                                    <div style={rowStyle}>
                                        <span style={labelStyle}>Autor</span>
                                        <span style={valueStyle}>{autor}</span>
                                    </div>
                                )}
                                {fechaCreacion && (
                                    <div style={rowStyle}>
                                        <span style={labelStyle}>Creado</span>
                                        <span style={valueStyle}>{fechaCreacion}</span>
                                    </div>
                                )}
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    fontSize: '10px',
                                    color: isDarkMode ? '#5a6a7e' : '#aab',
                                    marginTop: '2px',
                                    paddingTop: '6px',
                                    borderTop: `1px solid ${isDarkMode ? '#3d4a62' : '#eef0f8'}`,
                                }}>
                                    {`${lat || ''}, ${lng || ''}`}
                                </div>
                            </div>
                        </div>
                    </InfoWindow>
                </>
            )}
        </Marker>
    );
}

export default memo(MarkerClienteDash);
